<template>
        <v-card class="mx-auto" width="100%">
            <v-container grid-list-md fluid>
                <v-layout row>
                    <v-flex xs12 class="pb-0">
                        <v-card-title class="pb-0">Caso {{ caseNumber }} - Situación {{ situationNumber }}</v-card-title>
                    </v-flex>
                </v-layout>
                <v-layout row>
                    <v-flex xs12>
                        <v-card-text class="teal--text text--darken-3 title">
                            Un ejecutivo contestó lo siguiente:
                        </v-card-text>
                        <v-divider class="teal lighten-3"></v-divider>
                        <v-card-text class="teal--text text--darken-3 subtitle-1">
                            {{ autoevaluation.texto }}
                        </v-card-text>
                    </v-flex>
                </v-layout>

                <v-layout row v-if="autoevaluation.tipoAutoevaluacion === 0">
                    <v-flex xs12 sm6>
                        <v-card class="mx-auto" elevation="10">
                            <v-card-title class="teal--text text--darken-3 title font-weight-bold pt-3 pb-2">
                                Mi respuesta fue:
                            </v-card-title>
                            <v-card-text class="pt-0 pb-0">
                                <v-radio-group
                                    dense
                                    v-model="autoevaluation.respuesta"
                                    column
                                    >
                                        <v-radio
                                            label="Mejor"
                                            color="orange accent-4"
                                            value="1"
                                        ></v-radio>
                                        <v-radio
                                            label="Muy similar"
                                            color="orange accent-4"
                                            value="2"
                                        ></v-radio>
                                        <v-radio
                                            label="No tan buena, omití un punto"
                                            color="orange accent-4"
                                            value="3"
                                        ></v-radio>
                                        <v-radio
                                            label="No tan buena, omití más de un punto"
                                            color="orange accent-4"
                                            value="4"
                                        ></v-radio>
                                </v-radio-group>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-card class="mx-auto" elevation="10">
                            <v-card-title class="teal--text text--darken-3 title font-weight-bold pt-3 pb-2">
                                En realidad la respuesta fue:
                            </v-card-title>
                            <v-card-text class="pt-0 pb-0">
                                <v-radio-group
                                    dense
                                    v-model="autoevaluation.respuestaReal"
                                    column
                                    >
                                        <v-radio
                                            label="Mejor"
                                            color="orange accent-4"
                                            value="1"
                                        ></v-radio>
                                        <v-radio
                                            label="Muy similar"
                                            color="orange accent-4"
                                            value="2"
                                        ></v-radio>
                                        <v-radio
                                            label="No tan buena, omitió un punto"
                                            color="orange accent-4"
                                            value="3"
                                        ></v-radio>
                                        <v-radio
                                            label="No tan buena, omitió más de un punto"
                                            color="orange accent-4"
                                            value="4"
                                        ></v-radio>
                                </v-radio-group>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
                <v-layout row v-else justify-center>
                    <v-flex xs12 sm6>
                        <v-card class="mx-auto">
                            <v-card-title class="teal--text text--darken-3 body-1 font-weight-bold pt-3 pb-2">
                                Evaluación con información complementaria:
                            </v-card-title>
                            <v-card-text class="pt-0 pb-0">
                                <v-radio-group
                                    dense
                                    v-model="autoevaluation.infoComplementaria"
                                    column
                                    >
                                        <v-radio
                                            label="Mantengo, estaba bien"
                                            color="orange accent-4"
                                            value="1"
                                        ></v-radio>
                                        <v-radio
                                            label="Mantengo, estaba mal"
                                            color="orange accent-4"
                                            value="2"
                                        ></v-radio>
                                        <v-radio
                                            label="Cambio, estaba bien"
                                            color="orange accent-4"
                                            value="3"
                                        ></v-radio>
                                        <v-radio
                                            label="Cambio, estaba mal"
                                            color="orange accent-4"
                                            value="4"
                                        ></v-radio>
                                </v-radio-group>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'SituationAutoevaluation',
    data() {
        return {};
    },
    created() {},
    props: {
        caseNumber: Number,
        situationNumber: Number,
        autoevaluation: Object
    },
    methods: {

    },
    computed: {
        ...mapGetters(['waitCursor']),
        
        imgHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '200px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '250px';
            } else {
                height = '300px';
            }
            return height;
        },

    }
};
</script>